document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.before-after-container');
  
  containers.forEach(container => {
    const afterImage = container.querySelector('.after-image');
    const handle = container.querySelector('.slider-handle');
    let isDragging = false;
    
    const images = container.querySelectorAll('img');
    let loadedImages = 0;
    
    images.forEach(img => {
      if (img.complete) {
        loadedImages++;
      } else {
        img.addEventListener('load', () => {
          loadedImages++;
          if (loadedImages === images.length) {
            initSlider();
          }
        });
      }
    });
    
    if (loadedImages === images.length) {
      initSlider();
    }
    
    function initSlider() {
      updateSlider(container.getBoundingClientRect().left + (container.offsetWidth / 2));
    }
    
    function updateSlider(x) {
  const rect = container.getBoundingClientRect();
  const percentage = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
  
  afterImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
  handle.style.left = `${percentage}%`;
  
  const separatorLine = container.querySelector('.separator-line');
  if (separatorLine) {
    separatorLine.style.left = `${percentage}%`;
  }
}
    
    container.addEventListener('mousedown', (e) => {
      isDragging = true;
      updateSlider(e.clientX);
      e.preventDefault();
    });
    
    document.addEventListener('mousemove', (e) => {
      if (isDragging) {
        updateSlider(e.clientX);
        e.preventDefault();
      }
    });
    
    document.addEventListener('mouseup', () => {
      isDragging = false;
    });
    
    container.addEventListener('touchstart', (e) => {
      isDragging = true;
      updateSlider(e.touches[0].clientX);
      e.preventDefault();
    }, { passive: false });
    
    document.addEventListener('touchmove', (e) => {
      if (isDragging) {
        updateSlider(e.touches[0].clientX);
        e.preventDefault();
      }
    }, { passive: false });
    
    document.addEventListener('touchend', () => {
      isDragging = false;
    });
    
    container.addEventListener('click', (e) => {
      if (!isDragging) {
        updateSlider(e.clientX);
      }
    });
  });
});
